export enum ServiceTypes {
  BLOCKS = 'Blocks',
  USERS = 'Users',
  METADATA = 'Metadata',
  UPLOAD = 'Upload',
  PROJECTS = 'Projects',
  DATA_GRIDS = 'DataGrids',
  INGEST_JOBS = 'IngestJobs',
  GROUPS = 'Groups,',
  MICROSITE_TEMPLATE = 'MicrositeTemplate,',
  DOCUMENTS = 'Documents',
  PROJECT_TEMPLATES = 'ProjectTemplates',
  DOCUMENT_TEMPLATES = 'DocumentTemplates',
  JOBS = 'jobs',
  CCMS = 'CCMS',
  IMPERSONATE = 'Impersonate',
  GRANTS = 'grants',
  SLIDES = 'slides',
  PRESENTATION_THEMES = 'PresentationThemes',
  AI = 'ai',
  TAXONOMY = 'Taxonomy',
  SLIDE_REPOSITORIES = 'SlideRepositories',
}

export const SERVICE_API_TAG_TYPES = [
  'Folders',
  'Assets',
  'Types',
  'Entities',
  'ProjectTemplates',
  'Presentations',
  ServiceTypes.METADATA,
  ServiceTypes.GROUPS,
  ServiceTypes.UPLOAD,
  ServiceTypes.PROJECTS,
  ServiceTypes.DATA_GRIDS,
  ServiceTypes.INGEST_JOBS,
  ServiceTypes.DOCUMENT_TEMPLATES,
  ServiceTypes.JOBS,
  ServiceTypes.CCMS,
  ServiceTypes.DOCUMENTS,
  ServiceTypes.MICROSITE_TEMPLATE,
  ServiceTypes.BLOCKS,
  ServiceTypes.IMPERSONATE,
  ServiceTypes.GRANTS,
  ServiceTypes.SLIDES,
  ServiceTypes.PRESENTATION_THEMES,
  ServiceTypes.AI,
  ServiceTypes.TAXONOMY,
  ServiceTypes.SLIDE_REPOSITORIES,
] as const;
